import AspectWrapper from "core-web/components/AspectWrapper";
import Column from "theme/layouts/Column";
import Image from "core-web/components/Image";
import { PLACEHOLDER } from "theme/config/constants";
import PropTypes from "prop-types";
import React from "react";
import Row from "theme/layouts/Row";
import TextLink from "theme/components/text/TextLink";
import TextStyles from "theme/components/text/TextStyles";
import activeSetting from "theme/libs/wordpress/utils/activeSetting";
import colors from "theme/config/colors";
import useBelowBreakpoint from "core-web/hooks/useBelowBreakpoint";

const TeamMemberBlock = ({ image, name, role, email, phone, settings }) => {
    const isMobile = useBelowBreakpoint("tabletLg");
    const imageToUse = isMobile ? image?.mobile?.image : image?.desktop?.image;

    return (
        <article>
            <AspectWrapper ratio={1} background={colors.neutral_50} borderRadius="12px" mb="32px" overflow="hidden">
                <Image
                    src={{
                        url: imageToUse?.url || PLACEHOLDER,
                        width: [200, null, 230, 220, 300, 380, 420],
                    }}
                    alt={imageToUse?.alt || `${name}, ${role}`}
                    placeholder={PLACEHOLDER}
                    objectFit="cover"
                    objectPosition="top"
                    loading="lazy"
                />
            </AspectWrapper>
            <Column gap="8px">
                {name && <TextStyles textStyles="Myriad Pro/20-100-semibold">{name}</TextStyles>}
                {role && (
                    <TextStyles textStyles="Myriad Pro/18-140" color={colors.black_70}>
                        {role}
                    </TextStyles>
                )}
                {activeSetting(settings, "email") && email && (
                    <Row gap="8px">
                        <TextStyles textStyles="Myriad Pro/18-100" whiteSpace="nowrap">
                            {"E:"}
                        </TextStyles>
                        <TextLink to={`mailto:${email}`} textStyles="Myriad Pro/18-100">
                            {email}
                        </TextLink>
                    </Row>
                )}
                {activeSetting(settings, "phone") && phone && (
                    <Row gap="8px">
                        <TextStyles textStyles="Myriad Pro/18-100" whiteSpace="nowrap">
                            {"P:"}
                        </TextStyles>
                        <TextLink to={`tel:${phone}`} textStyles="Myriad Pro/18-100">
                            {phone}
                        </TextLink>
                    </Row>
                )}
            </Column>
        </article>
    );
};

TeamMemberBlock.propTypes = {
    image: PropTypes.object,
    name: PropTypes.string,
    role: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    settings: PropTypes.array,
};

TeamMemberBlock.defaultProps = {
    image: {},
    name: null,
    role: null,
    email: null,
    phone: null,
    settings: [],
};

export default TeamMemberBlock;
